export default {
  timberwolf: '#D8D8D8',
  title: '#2B3D41',
  green: '#339965',
  earthYellow: '#CEA15A',
  blue: '#3b79a9',
  navBackground: '#343a40',
  blueBackground: '#222831'
};
